import { LegalDocument } from '../../components/legal/LegalDocument';
import { privacyContent } from '../../content/legal/privacyContent';

export function AndroidPrivacy() {
  return (
    <LegalDocument
      content={privacyContent}
      platform="android"
      seoDescription="LuvLust Android Privacy Policy. Learn how we collect, use, and protect your information."
      seoKeywords="luvlust android privacy policy, data protection, couples app privacy"
    />
  );
}
